export default defineNuxtRouteMiddleware((_, from) => {
	const redirectStore = useRedirectStore()
	return redirectStore.setRedirectTo(from.path)
})
